<ng-container *ngIf="!isLoading">
    <div class="count">{{ count }}</div>
    <div class="label">{{ label }}</div>
</ng-container>
<ng-container *ngIf="isLoading">
    <app-skeleton [type]="'text'" class="count" [symbolsCount]="2"></app-skeleton>
    <app-skeleton [type]="'text'" class="label" [symbolsCount]="5"></app-skeleton>
</ng-container>
